export default "__VITE_ASSET__9Xt2EFUu__"